var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-preview-content"},[(_vm.formVisible)?_c('FormBuild',{ref:"formPreview",staticStyle:{"height":"100%"},attrs:{"formTemplate":_vm.formTemplate,"models":_vm.models,"renderPreview":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }